import { useColorScheme } from "@mui/joy/styles";
import { useColorScheme as useMaterialColorTheme } from "@mui/material/styles";
import { IconButton } from "@mui/joy";
import { useEffect } from "react";

export default function ModeToggle() {
  const { mode, setMode } = useColorScheme();
  const { mode: materialMode, setMode: setMaterialMode } =
    useMaterialColorTheme();

  const setMetaTags = ({ color }: { color: string }) => {
    //set title
    window.document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", `${color}`);
  };

  useEffect(() => {
    setMetaTags({ color: mode === "dark" ? "#313537" : "#E2E6E8" });
  }, [mode]);

  return (
    <IconButton
      size="sm"
      variant="plain"
      color="neutral"
      onClick={() => {
        setMode(mode === "dark" ? "light" : "dark");
        setMaterialMode(materialMode === "dark" ? "light" : "dark");
      }}
    >
      {mode === "dark" ? (
        <span className="material-symbols-outlined ">light_mode</span>
      ) : (
        <span className="material-symbols-outlined ">dark_mode</span>
      )}
    </IconButton>
  );
}
